import PropTypes from 'prop-types';
import React from 'react';
import MainPage from '../../components/MainPage.react';
import CrossChannelIndexStore from '../../stores/CrossChannelIndexStore';
import CurrentOrganizationStore from '../../stores/CurrentOrganizationStore';
import CrossChannelActions from '../../actions/CrossChannelActions';
import ScenarioView from './components/ScenarioView.react';

import JobActions from '../../actions/JobActions';
import LogStore from '../../stores/LogStore';
import QueryStore from '../../stores/QueryStore';

function determineLastRunId(scenario) {
  if ((scenario || {}).lastRun) {
    return scenario.lastRun.id;
  }
  return null;
}

function determineQueryName(scenario, queryType) {
  // This very, very carefully pokes at params and eventually returns a query's name from ID
  const scenarioParameters = (scenario || {}).parameters;
  const queryId = (scenarioParameters || {})[queryType];
  if (queryId) {
    return (QueryStore.getQuery(scenario.parameters[queryType]) || {}).name;
  }
  return null;
}

function getStateFromProps(scenarioId) {
  const scenario = CrossChannelIndexStore.getScenario(scenarioId);
  const organization = CurrentOrganizationStore.getState();
  return {
    scenario,
    logs: LogStore.getLogs(determineLastRunId(scenario)),
    queries: {
      targetUniverse: determineQueryName(scenario, 'targetUniverse'),
      upliftScore: determineQueryName(scenario, 'upliftScore'),
      targetListSubsetUniverse: determineQueryName(scenario, 'targetListSubsetUniverse'),
    },
    organization,
  };
}

export default class CrossChannelShow extends React.Component {
  constructor(props) {
    super(props);
    this.state = getStateFromProps(this.props.params.scenarioId);
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    this.ScenarioStoreSubscription = CrossChannelIndexStore.addListener(this._onChange);
    this.logStoreSubscription = LogStore.addListener(this._onChange);
    this.queryStoreSubscription = QueryStore.addListener(this._onChange);
    CrossChannelActions.loadScenarios();
    CrossChannelActions.loadSourceTables();
  }

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (!this.jobSubscription && determineLastRunId(nextState.scenario)) {
      this.scenarioSubscription = CrossChannelActions.pollForScenarios();
      this.jobSubscription = JobActions.startPolling(determineLastRunId(nextState.scenario));
    } else if (this.jobSubscription && (nextState.scenario.status === 'finished' || nextState.scenario.status === 'failed')) {
      this.jobSubscription(); // unset polling on job logs
      this.scenarioSubscription(); // unset polling on scenario updates
    }
  }

  componentWillUnmount() {
    this.ScenarioStoreSubscription.remove();
    this.logStoreSubscription.remove();
    this.queryStoreSubscription.remove();

    if (this.jobSubscription) {
      this.jobSubscription();
      this.scenarioSubscription();
    }
  }

  _onChange() {
    this.setState(getStateFromProps(this.props.params.scenarioId));
  }

  render() {
    return (
      <MainPage>
        { this.state.scenario &&
          <ScenarioView
            scenario={this.state.scenario}
            logs={this.state.logs}
            queries={this.state.queries}
            organization={this.state.organization}
          />
        }
      </MainPage>
    );
  }
}

CrossChannelShow.propTypes = {
  params: PropTypes.shape({
    scenarioId: PropTypes.string,
  }),
};
